<template>
  <div class="multi-phone">
    <div
      class="phone-item"
      v-for="(phone, index) in phoneList"
      :key="index"
    >
      <i
        class="icon-delete1 remove-btn"
        @click="removeItem(index)"
      ></i>
      <rich-button
        class="switch-btn"
        inline
        outline
        @click="showTypePicker(index)"
      >{{getPhoneTypeText(phone.type)}}<i class="richic-pulldown"></i></rich-button>
      <phone-input v-model="phone.value"></phone-input>
    </div>
    <div>
      <rich-button
        inline
        primary
        icon="richic-add"
        v-show="phoneList.length < 3"
        @click="addItem"
      >{{gettext('添加电话')}}</rich-button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { i18n } from '@/common/utils/i18n'
import PhoneInput from './PhoneInput'
const PHONE_TYPE_OPTIONS = [
  {
    text: i18n.gettext('手机'),
    value: 1
  },
  {
    text: i18n.gettext('座机'),
    value: 2
  }
]
export default {
  name: 'MultiPhone',
  components: {
    PhoneInput
  },
  props: {
    value: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      phoneList: this.value.slice(0)
    }
  },
  watch: {
    phoneList: {
      deep: true,
      handler (nVal) {
        this.$emit('input', nVal)
      }
    }
  },
  methods: {
    getPhoneTypeText (value) {
      return PHONE_TYPE_OPTIONS.find(i => i.value === value).text
    },
    addItem () {
      this.phoneList.push({
        type: 1,
        value: ''
      })
    },
    removeItem (index) {
      this.$createDialog({
        type: 'confirm',
        icon: 'richic-alert',
        title: this.gettext('确定删除吗？'),
        onConfirm: () => {
          this.phoneList.splice(index, 1)
        }
      }).show()
    },
    showTypePicker (index) {
      this.$createPicker({
        title: this.gettext('请选择'),
        data: [PHONE_TYPE_OPTIONS],
        selectedIndex: [PHONE_TYPE_OPTIONS.findIndex(i => i.value === this.phoneList[index].type)],
        onSelect: this.switchType.bind(this, index)
      }).show()
    },
    switchType (phoneIndex, selectedVals) {
      this.phoneList[phoneIndex] = Object.assign(this.phoneList[phoneIndex], {
        type: selectedVals[0]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .multi-phone {
    .phone-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      ::v-deep .phone-input {
        flex: 1;
      }
      .switch-btn {
        margin:0 20px;
      }
    }
    .remove-btn {
      padding: 10px;
      color: $color-grey;
      font-size: 36px;
    }
  }
</style>
